import React from "react";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import CoverArt from "./components/CoverArt";

import Plans from "./components/Plans";
import Footer from "./components/Footer";
import "./App.css";
import ScrollProgress from "./components/ScrollProgress";
import Reels from "./components/Reels";
import FloatingButtons from "./components/FloatingButtons";
import Vfx from "./components/Vfx";

import LoadingScreen from "./components/LoadingScreen"; 

import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <LoadingScreen> {/* 🔥 ENVOLVEMOS TODA LA WEB */}
      <div className="app">
        <Navbar />
        <ScrollProgress />
        <Hero />
        <div className="section-separator"></div>
        <CoverArt />
        <div className="section-separator"></div>
        <Reels />
        <div className="section-separator"></div>
        <Vfx />
        <div className="section-separator"></div>
        <Plans />
        <FloatingButtons />
        <Footer />

        <Analytics/>
      </div>
    </LoadingScreen>
  );
}

export default App;
